import ENoticeContainer from './ENoticeContainer';

export default ENoticeContainer;
